import { render } from "./IdCheck.vue?vue&type=template&id=64096677&scoped=true"
import script from "./IdCheck.vue?vue&type=script&lang=js"
export * from "./IdCheck.vue?vue&type=script&lang=js"

import "./IdCheck.vue?vue&type=style&index=0&id=64096677&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64096677"]])

export default __exports__